const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function getVisitorId() {
  let id = localStorage.getItem("fff_visitor_id");
  if (!id) {
    id = "v_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8);
    localStorage.setItem("fff_visitor_id", id);
  }
  return id;
}

export function trackEvent(eventType, label = null, page = null) {
  const payload = {
    event_type: eventType,
    page: page || window.location.pathname,
    label,
    visitor_id: getVisitorId(),
  };

  // Fire and forget — don't block UI
  fetch(`${BACKEND_URL}/api/analytics/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).catch(() => {});

  // Also send to Google Analytics if available
  if (window.gtag) {
    window.gtag("event", eventType, { event_label: label, page_location: page });
  }
}

export function trackPageView() {
  trackEvent("page_view", document.title);
}

export function trackCTAClick(label) {
  trackEvent("cta_click", label);
}

export function trackChatStart() {
  trackEvent("chat_start");
}

export function trackChatMessage() {
  trackEvent("chat_message");
}

export function trackContactSubmit() {
  trackEvent("contact_submit");
}
